import { Link, Typography } from '@mui/material';
import { LinkSectionRow } from '../../interfaces';

type Props = {
  label: string;
  values: LinkSectionRow['value'];
};

export default function SectionLinkRow({ label, values }: Props) {
  return (
    <div className="section-row">
      <Typography variant="overline" component="p">
        {label}
      </Typography>
      {values.map((value, index) => (
        <Link
          // eslint-disable-next-line react/no-array-index-key
          key={index}
          href={value.url}
          target="_blank"
          rel="noopener noreferrer"
          sx={{
            fontSize: theme => theme.typography.body2.fontSize,
            color: theme => theme.palette.primary.main,
          }}>
          {value.label}
        </Link>
      ))}
    </div>
  );
}
